export default __webpack_public_path__ + "static/media/FlagOfPoland.5affda54.svg";